"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Provider = void 0;
var _react = require("react");
/**
 * Test id context
 * @interface
 */

const testIdContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const {
  Provider
} = testIdContext;
exports.Provider = Provider;
var _default = exports.default = testIdContext;
//# sourceMappingURL=testIdContext.js.map